/// <amd-module name="Wit/LinkedWorkItemsDropdown/Components/LinkedWorkItemsChangesetDetails" />
import * as React from "react";
import { onClickFPS } from "VSS/Platform/FPS";
import { Components, VssComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { ReadyableArrayObserver } from "VSSUI/Observer";
import { ITableRow } from "VSSUI/Table";
import * as Resources from "Wit/LinkedWorkItemsDropdown/Resources";
import { getLinkedWorkItemsChangesetDetailViewService } from "../LinkedWorkItemsChangesetDetailViewService";
import { IWorkItemEntry } from "../Util/Data";
import { LinkedWorkItemsTable } from "./LinkedWorkItemsTable";

interface ILinkedWorkItemsChangesetDetailsProps {
    changesetId: number;
}

export class LinkedWorkItemsChangesetDetails extends VssComponent<ILinkedWorkItemsChangesetDetailsProps> {
    public render() {
        const viewService = getLinkedWorkItemsChangesetDetailViewService(this.context.pageContext);

        return (
            <div className="flex-column rhythm-vertical-8">
                <ReadyableArrayObserver
                    data={viewService.getLinkedWorkItems("", "", this.props.changesetId)}
                    dataComponent={this.renderDataComponent}
                />
            </div>
        );
    }

    private renderDataComponent = () => {
        const viewService = getLinkedWorkItemsChangesetDetailViewService(this.context.pageContext);

        return (
            <Card className="bolt-table-card" titleProps={{ text: Resources.WorkItems }}>
                <LinkedWorkItemsTable
                    expanded={true}
                    itemProvider={viewService.getLinkedWorkItems("", "", this.props.changesetId)}
                    onActivate={(event: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<IWorkItemEntry>) => {
                        if (!event.defaultPrevented) {
                            onClickFPS(this.context.pageContext, tableRow.data.href!, true, event);
                        }
                    }}
                />
            </Card>
        );
    };
}
Components.add("WIT.LinkedWorkItemsChangesetDetails", LinkedWorkItemsChangesetDetails);
